module.exports = __webpack_public_path__ + "img/outlander4.b62dfd92.jpeg";